// Consts
export const ON_BETA_DASHBOARD_MOUNT = 'ON_BETA_DASHBOARD_MOUNT';
export const ON_BETA_DASHBOARD_MOUNT_ERROR = 'ON_BETA_DASHBOARD_MOUNT_ERROR';
export const ON_BETA_DASHBOARD_TIME_FILTER_CHANGE = 'ON_BETA_DASHBOARD_TIME_FILTER_CHANGE';
export const ON_BETA_DASHBOARD_SELECTED_EVENT_FILTER_CHANGE = 'ON_BETA_DASHBOARD_SELECTED_EVENT_FILTER_CHANGE';
export const ON_CLOSE_SELECT_EVENT_MODAL_CLICKED = 'ON_CLOSE_SELECT_EVENT_MODAL_CLICKED';
export const ON_BETA_DASHBOARD_FETCH_ACCOUNT_REPORT_STARTED = 'ON_BETA_DASHBOARD_FETCH_ACCOUNT_REPORT_STARTED';
export const ON_BETA_DASHBOARD_FETCH_ACCOUNT_REPORT_ERROR = 'ON_BETA_DASHBOARD_FETCH_ACCOUNT_REPORT_ERROR';
export const ON_BETA_DASHBOARD_FETCH_ACCOUNT_REPORT_SUCCESS = 'BETA_DASHBOARD_FETCH_ACCOUNT_REPORT_SUCCESS';
export const ON_BETA_DASHBOARD_FETCH_BALANCES_SUCCESS = 'BETA_DASHBOARD_FETCH_BALANCES_SUCCESS';
export const ON_SELECTED_CURRENCY_CHANGE = 'ON_SELECTED_CURRENCY_CHANGE';


// Actions
export const onBetaDashboardTimeFilterChange = (value) => ({
  type: ON_BETA_DASHBOARD_TIME_FILTER_CHANGE,
  payload: value
});

export const onBetaDashboardEventFilterChange = (value) => ({
  type: ON_BETA_DASHBOARD_SELECTED_EVENT_FILTER_CHANGE,
  payload: value
});

export const onDashboardMount = () => ({
  type: ON_BETA_DASHBOARD_MOUNT
});

export const onCloseSelectEventsModalClicked = () => ({
  type: ON_CLOSE_SELECT_EVENT_MODAL_CLICKED
});

export const onSelectedCurrencyChange = (currency) => ({
  type: ON_SELECTED_CURRENCY_CHANGE,
  payload: currency
});



// WEBPACK FOOTER //
// ./src/modules/beta-dashboard/actions.js